<template>
    <div class="Empleado">
        <v-container grid-list-xl fluid v-show="!showDetails" class="pt-0">
            <v-layout row wrap>
                <v-flex sm12>
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>
                                <v-icon medium>fa fa-group</v-icon>
                                Lista de Colaboradores
                            </v-toolbar-title>

                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-flex sm3 class="pa-0" style="max-width: 190px">
                                <v-overflow-btn
                                    v-model="empleadoEstado"
                                    label="Empleados"
                                    :items="[
                                        { text: 'Todos', value: '1' },
                                        { text: 'Activos', value: '2' },
                                        { text: 'Pendientes', value: '3' },
                                        { text: 'Bajas', value: '4' },
                                        { text: 'Rechazados', value: '5' }
                                    ]"
                                    hide-details
                                    class="pa-0"
                                    @change="loadEmpleado()"
                                >
                                    <template v-slot:item="data">
                                        <v-list-tile-content>
                                            <v-card-text class="pa-0 ">
                                                <v-icon
                                                    :color="getIconColor(data)"
                                                    class="pr-3"
                                                    v-if="data.item.value !== '1'"
                                                    >fa-list</v-icon
                                                >
                                                {{ data.item.text }}
                                            </v-card-text>
                                        </v-list-tile-content>
                                    </template>
                                </v-overflow-btn>
                            </v-flex>

                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-btn icon @click="toogleSearch()">
                                    <v-icon medium>fa fa-search</v-icon>
                                </v-btn>

                                <v-expand-x-transition>
                                    <v-text-field
                                        hide-details
                                        solo
                                        v-show="searchShow"
                                        v-model="filter.search"
                                        placeholder="Filtrar"
                                        class="hidden-sm-and-down pt-2"
                                    >
                                    </v-text-field>
                                </v-expand-x-transition>

                                <v-menu
                                    v-model="menufiltro"
                                    class="elevation-1"
                                    transition="slide-y-transition"
                                    top
                                    left
                                    min-width="500"
                                    max-height="500"
                                    :close-on-content-click="false"
                                >
                                    <template v-slot:activator="{ on: menu }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn icon flat>
                                                    <v-badge color="orange" overlap>
                                                        <span slot="badge" v-if="activeFilters > 0">{{
                                                            activeFilters
                                                        }}</span>
                                                        <v-icon medium v-on="{ ...tooltip, ...menu }">fa-filter</v-icon>
                                                    </v-badge>
                                                </v-btn>
                                            </template>
                                            <span>Filtro Personalizado</span>
                                        </v-tooltip>
                                    </template>
                                    <custom-filter-empleado
                                        v-if="menufiltro"
                                        :internal-state="filterInternalState"
                                        @applyFilter="applyFilter"
                                    ></custom-filter-empleado>
                                </v-menu>
                                <!--seccion de exporatr empleados-->
                                <!--                                <v-menu-->
                                <!--                                    v-model="menu"-->
                                <!--                                    origin="center center"-->
                                <!--                                    class="elelvation-1"-->
                                <!--                                    transition="slide-y-transition"-->
                                <!--                                    left-->
                                <!--                                    max-width="350"-->
                                <!--                                    max-height="500"-->
                                <!--                                    :close-on-content-click="false"-->
                                <!--                                >-->
                                <!--                                    <template v-slot:activator="{ on: menu }">-->
                                <!--                                        <v-tooltip bottom>-->
                                <!--                                            <template v-slot:activator="{ on: tooltip }">-->
                                <!--                                                <v-btn icon flat>-->
                                <!--                                                    <v-icon medium v-on="{ ...tooltip, ...menu }">fa-download</v-icon>-->
                                <!--                                                </v-btn>-->
                                <!--                                            </template>-->
                                <!--                                            <span>Exportar Empleados</span>-->
                                <!--                                        </v-tooltip>-->
                                <!--                                    </template>-->
                                <!--                                    <v-card>-->
                                <!--                                        <v-card-text pb-0>-->
                                <!--                                            <v-text-field v-model="filename" label="Nombre del documento">-->
                                <!--                                            </v-text-field>-->
                                <!--                                            <v-text-field v-model="sheetname" label="Nombre de la hoja"> </v-text-field>-->

                                <!--                                            <v-flex sm12 class="pb-3">-->
                                <!--                                                <v-label>Columnas a exportar</v-label>-->
                                <!--                                            </v-flex>-->
                                <!--                                            <v-container fluid grid-list-xl py-0>-->
                                <!--                                                <v-layout align-center wrap>-->
                                <!--                                                    <v-flex-->
                                <!--                                                        xs12-->
                                <!--                                                        sm6-->
                                <!--                                                        class="pa-0"-->
                                <!--                                                        v-for="column in excelColumns"-->
                                <!--                                                        :key="column.field"-->
                                <!--                                                    >-->
                                <!--                                                        <v-checkbox-->
                                <!--                                                            v-model="column.status"-->
                                <!--                                                            class="pt-0 mt-0"-->
                                <!--                                                            :label="column.label"-->
                                <!--                                                            :key="column.field"-->
                                <!--                                                        >-->
                                <!--                                                        </v-checkbox>-->
                                <!--                                                    </v-flex>-->
                                <!--                                                </v-layout>-->
                                <!--                                            </v-container>-->
                                <!--                                        </v-card-text>-->
                                <!--                                        <v-divider></v-divider>-->
                                <!--                                        <v-card-actions>-->
                                <!--                                            <v-spacer></v-spacer>-->
                                <!--                                            <v-btn color="red" flat @click="menu = false">-->
                                <!--                                                Cancelar-->
                                <!--                                            </v-btn>-->
                                <!--                                            <v-btn @click="menu = false" color="success" flat>-->
                                <!--                                                Exportar-->
                                <!--                                            </v-btn>-->
                                <!--                                        </v-card-actions>-->
                                <!--                                    </v-card>-->
                                <!--                                </v-menu>-->

                                <v-divider class="pa-2"></v-divider>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon flat @click="openForm(null)">
                                            <v-icon medium v-on="on">fa fa-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Agregar Colaborador</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="headers"
                                :loading="loading"
                                :pagination.sync="pagination"
                                :rows-per-page-items="pagination.rowsPerPageItems"
                                :total-items="totalItems"
                                :items="EMPLEADOS"
                                class="elevation-1"
                                item-key="id"
                            >
                                <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td>{{ props.item.codigo }}</td>
                                        <td>
                                            {{
                                                props.item.nombre +
                                                    " " +
                                                    props.item.apellido_paterno +
                                                    " " +
                                                    props.item.apellido_materno
                                            }}
                                        </td>
                                        <td>{{ props.item.campus ? props.item.campus.nombre : "-" }}</td>
                                        <td>
                                            {{ props.item.departamento ? props.item.departamento.nombre : "-" }}
                                        </td>
                                        <td>{{ props.item.seccion ? props.item.seccion.nombre : "-" }}</td>
                                        <td>{{ props.item.puesto ? props.item.puesto.nombre : "-" }}</td>
                                        <td>
                                            <v-chip
                                                small
                                                dark
                                                :color="getChipColor(props.item)"
                                                style="font-size: 12px"
                                            >
                                                {{
                                                    props.item.status_description ? props.item.status_description : "-"
                                                }}
                                            </v-chip>
                                            <div class="action-column">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="grey"
                                                            :disabled="menuLocked"
                                                            @click="openDetails(props.item)"
                                                        >
                                                            <v-icon medium v-on="on">fa-eye</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Ver detalles</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="orange"
                                                            :disabled="menuLocked"
                                                            @click="openForm(props.item)"
                                                        >
                                                            <v-icon medium v-on="on">fa fa-edit</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Editar Colaborador</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="primary"
                                                            :disabled="menuLocked"
                                                            @click="expandRow(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-list</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Opciones</span>
                                                </v-tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:expand="props">
                                    <v-card>
                                        <v-card-text class="py-0 pl-0 text-xs-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        v-if="
                                                            props.item.recontratacion === 1 ||
                                                                props.item.recontratacion === 2
                                                        "
                                                        flat
                                                        icon
                                                        :color="getRecontratacionDatos(props.item).iconColor"
                                                        @click="deleteItem(props)"
                                                    >
                                                        <v-icon medium v-on="on">{{
                                                            getRecontratacionDatos(props.item).icon
                                                        }}</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ getRecontratacionDatos(props.item).label }}</span>
                                            </v-tooltip>
                                            <template
                                                v-if="props.item.recontratacion === 3 && isNotUserRRHH_Asistente()"
                                            >
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn flat icon color="primary" @click="aprobarItem(props)">
                                                            <v-icon medium v-on="on">fa-thumbs-up</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Aprobar</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn flat icon color="red" @click="rechazarItem(props)">
                                                            <v-icon medium v-on="on">fa-thumbs-down</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Rechazar</span>
                                                </v-tooltip>
                                            </template>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn flat icon color="grey" @click="loadAsistencia(props)">
                                                        <v-icon medium v-on="on">fa-check-square</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Ver Asistencia</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                        flat
                                                        icon
                                                        color="grey"
                                                        :loading="loadingHistory"
                                                        @click="loadHistory(props)"
                                                    >
                                                        <v-icon medium v-on="on">fa-archive</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Ver historial</span>
                                            </v-tooltip>
                                            <v-divider vertical class="pl-2"></v-divider>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="red" @click="expandRowCancel(props)">
                                                        <v-icon v-on="on">fa-close</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Cancelar acción</span>
                                            </v-tooltip>
                                        </v-card-text>
                                    </v-card>
                                </template>
                                <template slot="no-data">
                                    <div style="text-align: center">
                                        No existen Colaboradores registrados en el sistema.
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <empleado-form v-if="showForm" :form-title="title" :initial-item="editItem" @formCanceled="closeForm">
        </empleado-form>

        <empleado-details v-if="showDetails" :item="detailsItem" @detailsCanceled="closeDetails"> </empleado-details>

        <time-line
            v-if="showHistory"
            :data="historyData"
            :element="'Empleado'"
            @formCanceled="showHistory = false"
        ></time-line>

        <asistencia-dialog
            v-if="showAsistencia"
            :initial-item="asistenciaData"
            @formCanceled="showAsistencia = false"
        ></asistencia-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import _ from "lodash"
import Util from "@/util"
const AsistenciaDialog = () =>
    import(/* webpackChunkName: "asistencia-dialog" */ "@/components/personal/empleado/asistencia-dialog/asistencia-dialog")
const TimeLine = () =>
    import(/* webpackChunkName: "historial-time-line" */ "@/components/widgets/records-time-line/time-line")
const CustomFilterEmpleado = () =>
    import(/* webpackChunkName: "filtro-empleado" */ "@/components/widgets/custom-filter-empleado/custom-filter-empleado")
const EmpleadoForm = () =>
    import(/* webpackChunkName: "empleado-form" */ "@/components/personal/empleado/empleado-form/empleado-form")
const EmpleadoDetails = () =>
    import(/* webpackChunkName: "empleado-details" */ "@/views/personal/empleado/Empleado/empleado-details")
export default {
    components: { AsistenciaDialog, CustomFilterEmpleado, EmpleadoDetails, EmpleadoForm, TimeLine },
    props: {
        //estado de los empleados a cargar del back
        estado: { type: String, default: null }
    },
    data: () => ({
        searchShow: false,
        loading: false,
        title: "",
        showForm: false,
        headers: [
            { text: "Código", value: "codigo" },
            { text: "Colaborador", value: "nombre" },
            { text: "Campus", value: "campus_id" },
            { text: "Departamento", value: "departamento_id" },
            { text: "Sección", value: "seccion_id" },
            { text: "Puesto", value: "puesto_id" },
            { text: "Estado", value: "recontratacion" }
        ],
        editItem: null,
        filter: {
            search: ""
        },
        totalItems: 0,

        deleteEmpleadoConfirmId: "",

        menuIndex: null,

        showDetails: false,
        detailsItem: null,

        //excel a exportar
        excelColumns: Util.EmpleadoExcelColumns(),
        menu: false,
        filename: "empleados",
        sheetname: "seleccion",

        //filtro personalizado
        menufiltro: false,
        customFilter: null,
        activeFilters: 0,

        //estado de los empleados a cargar del back
        empleadoEstado: "2",

        //para saber si ya se aplico el valor obtenido por las props
        estadoApplied: false,

        //para saber si hay una columna expandida
        columnExpanded: false,

        //history
        loadingHistory: false,
        showHistory: false,
        historyData: null,

        //asistencia
        showAsistencia: false,
        asistenciaData: null,

        //estado interno del filtro
        filterInternalState: null
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado, customFilter) {
            this.loading = true
            this.$store
                .dispatch("LOAD_EMPLEADOS", {
                    filter: this.filter.search,
                    empleadoEstado: estado,
                    customfilter: customFilter
                })
                .then(result => {
                    this.loading = false
                    this.totalItems = result
                })
        },

        openForm(item) {
            if (item !== null) {
                this.title = "Modificar colaborador"
                this.editItem = item
            } else {
                this.title = "Nuevo colaborador"
            }
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },

        deleteItem(props) {
            this.loading = true
            this.$store.dispatch("TOGGLE_STATUS_EMPLEADO", props.item).then(() => {
                this.loading = false
            })
        },

        aprobarItem(props) {
            this.loading = true
            this.$store.dispatch("APROBE_EMPLEADO", props.item).then(() => {
                this.loading = false
            })
        },

        rechazarItem(props) {
            this.loading = true
            this.$store.dispatch("REJECT_EMPLEADO", props.item).then(() => {
                this.loading = false
            })
        },

        loadEmpleado() {
            this.loadData(this.empleadoEstado)
            this.customFilter = null
            this.activeFilters = 0
        },

        searchData: _.debounce(function() {
            this.loadData(this.empleadoEstado, this.customfilter)
        }, 1000),

        closeDetails() {
            this.showDetails = false
            this.detailsItem = null
        },

        openDetails(item) {
            if (!this.EMPLEADOS.filter(el => el.id === item.id)[0].salario_bruto) {
                //condicion para saber si los datos de este empleado ya se cargaron para no volver a pedirlos
                this.loading = true
                this.$store.dispatch("LOAD_EMPLEADO_DETAILS", item).then(error => {
                    if (error === null) {
                        this.detailsItem = item
                        this.loading = false
                        this.showDetails = true
                    } else {
                        this.loading = false
                    }
                })
            } else {
                this.detailsItem = item
                this.showDetails = true
            }
        },

        getRecontratacionDatos(item) {
            switch (item.recontratacion) {
                case 1:
                    return { textColor: "", icon: "fa-pause", iconColor: "red", label: "Terminar contrato" }
                case 2:
                    return { textColor: "red--text", icon: "fa-play", iconColor: "primary", label: "Recontratar" }
                case 3:
                    return { textColor: "orange--text", icon: "", iconColor: "", label: "" }
                case 4:
                    return { textColor: "grey--text", icon: "", iconColor: "", label: "" }
                default:
                    return ""
            }
        },

        applyFilter(value) {
            if (value.activeFilters > 0) {
                this.menufiltro = false
                this.empleadoEstado = "6"
                this.customfilter = value.customFilter
                this.activeFilters = value.activeFilters
                this.loadData(this.empleadoEstado, this.customfilter)
            } else {
                this.empleadoEstado = "1"
                this.customfilter = null
                this.activeFilters = 0
                this.loadData(this.empleadoEstado, this.customfilter)
                this.menufiltro = false
            }

            this.filterInternalState = {
                inputs: value.internalState.inputs,
                selectedCampos: value.internalState.selectedCampos
            }
        },

        isNotUserRRHH_Asistente() {
            let roles = this.$store.getters.CURRENT_USER.roles.filter(rol => rol.name !== "rrhh_asistente")
            return roles.length > 0
        },

        expandRow(props) {
            this.columnExpanded = !this.columnExpanded
            props.expanded = !props.expanded
        },

        expandRowCancel(props) {
            this.columnExpanded = false
            props.expanded = !props.expanded
        },

        loadHistory(props) {
            this.loadingHistory = true

            let historyClassName = Util.getHistoryClassName("Empleado")
            this.$store.commit("SET_HISTORIALES_TIME_LINE_PAG", { page: 1 })
            this.$store
                .dispatch("LOAD_HISTORIALES_TIME_LINE", { class: historyClassName, class_id: props.item.id })
                .then(response => {
                    if (response) {
                        this.historyData = this.$store.getters.HISTORIALES_TIME_LINE.historiales
                        this.showHistory = true
                        this.loadingHistory = false
                        this.expandRowCancel(props)
                    } else {
                        this.loadingHistory = false
                        this.expandRowCancel(props)
                    }
                })
        },

        loadAsistencia(props) {
            this.loading = true
            if (!this.$store.getters.EMPLEADOS.filter(el => el.id === props.item.id)[0].asistencia_totales) {
                //si no se ha cargado la asistencia del empleado solicitado
                this.$store.dispatch("LOAD_ASISTENCIA_TOTALES_EMPLEADO", props.item).then(() => {
                    this.loading = false

                    if (this.$store.getters.EMPLEADOS.filter(el => el.id === props.item.id)[0].asistencia_totales) {
                        this.asistenciaData = this.$store.getters.EMPLEADOS.filter(el => el.id === props.item.id)[0]
                        this.showAsistencia = true
                        this.expandRowCancel(props)
                    }
                })
            } else {
                this.loading = false
                this.asistenciaData = this.$store.getters.EMPLEADOS.filter(el => el.id === props.item.id)[0]
                this.showAsistencia = true
                this.expandRowCancel(props)
            }
        },

        getChipColor(item) {
            switch (item.recontratacion) {
                case 1:
                    return "success lighten-1"
                case 3:
                    return "orange lighten-1"
                case 2:
                    return "grey lighten-1"
                case 4:
                    return "red lighten-1"
            }
        },

        getIconColor(data) {
            switch (data.item.value) {
                case "1":
                    return "black"
                case "2":
                    return "success lighten-1"
                case "3":
                    return "orange lighten-1"
                case "4":
                    return "grey lighten-1"
                case "5":
                    return "red lighten-1"
                default:
                    return "black"
            }
        }
    },

    computed: {
        ...mapGetters(["EMPLEADOS"]),

        pagination: {
            get: function() {
                return this.$store.getters.EMPLEADOS_PAG
            },
            set: function(value) {
                this.$store.commit("SET_EMPLEADOS_PAG", value)
            }
        },
        searchTerm() {
            return this.filter.search
        },

        computedEmpleadosColumns() {
            let columns = []
            this.excelColumns.map(el => {
                if (el.status) {
                    columns.push(el.field)
                }
            })

            return columns
        },

        menuLocked() {
            return this.loading || this.menufiltro || this.columnExpanded
        }
    },

    watch: {
        pagination: {
            handler() {
                if (this.estado && !this.estadoApplied) {
                    //si se envio el valor estado por las props y no se ha aplicado, se aplica una sola vez
                    this.empleadoEstado = this.estado
                    this.estadoApplied = true
                }
                this.loadData(this.empleadoEstado, this.customfilter)
            },
            deep: true
        },
        searchTerm() {
            this.searchData()
        }
    }
}
</script>
